import { Link } from "react-router-dom";
import { channelCategories } from "@/mocks/channels";

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-primary-950">
      <div className="w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-live-line text-xl" />
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                360<span className="text-primary-300">直播</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-400">
              多频道高清视频直播平台，覆盖游戏、娱乐、体育等丰富内容。随时随地免费在线观看，与千万观众一起互动交流。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-bilibili-line", "ri-youtube-line"].map(
                (icon) => (
                  <span
                    key={icon}
                    className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50/10 text-foreground-300 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    <i className={`${icon} text-base`} />
                  </span>
                )
              )}
            </div>
          </div>

          <div>
            <h4 className="mb-4 font-label text-sm font-semibold text-foreground-950">快速导航</h4>
            <ul className="flex flex-col gap-3 text-sm text-foreground-400">
              {[
                { to: "/", label: "首页" },
                { to: "/channels", label: "频道分类" },
                { to: "/community", label: "互动社区" },
                { to: "/feedback", label: "用户反馈" },
                { to: "/about", label: "关于我们" },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="transition-colors hover:text-primary-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-label text-sm font-semibold text-foreground-950">直播频道</h4>
            <ul className="flex flex-col gap-3 text-sm text-foreground-400">
              {channelCategories.map((channel) => (
                <li key={channel.key}>
                  <Link
                    to={`/channels?category=${channel.key}`}
                    className="transition-colors hover:text-primary-300"
                  >
                    {channel.name}直播
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/search?q=解说" className="transition-colors hover:text-primary-300">
                  赛事解说
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-label text-sm font-semibold text-foreground-950">联系我们</h4>
            <ul className="flex flex-col gap-3 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-300" />
                support@360zhibo.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-300" />
                在线客服 09:00 - 22:00
              </li>
              <li>
                <Link
                  to="/feedback"
                  className="inline-flex items-center gap-1 text-primary-300 transition-colors hover:text-primary-200"
                >
                  提交反馈
                  <i className="ri-arrow-right-line" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="flex w-full flex-col gap-3 px-4 py-5 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 360直播 · 本平台为演示版本，内容仅供展示。</p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="cursor-pointer transition-colors hover:text-foreground-300">
              用户协议
            </span>
            <span className="cursor-pointer transition-colors hover:text-foreground-300">
              隐私政策
            </span>
            <span className="cursor-pointer transition-colors hover:text-foreground-300">
              版权声明
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}